export default __webpack_public_path__ + "static/media/MobileImageItemKo1.b3ec65a4.png";